import { unwrap } from "@sagot/api-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApi } from "../../../session/session-provider";
import { useWorkspaceId } from "../../../session/workspace-context";
import { dkKeys } from "../shared/keys";

/**
 * Go-live actions for the agent behind a widget. Public widget routes only serve `live` agents, so
 * Widget Studio offers `publish` (draft → live) and `resume` (paused → live). Both refresh every
 * cached agent query so the notice, header badge and agent lists reflect the new status.
 */
export function useAgentLifecycle(agentId: string) {
  const api = useApi();
  const wsId = useWorkspaceId();
  const client = useQueryClient();
  const path = { params: { path: { agent_id: agentId } } };
  const refresh = () =>
    Promise.all([client.invalidateQueries({ queryKey: dkKeys.agentTree(wsId) }), client.invalidateQueries({ queryKey: dkKeys.agents(wsId) })]);
  const publish = useMutation({
    mutationFn: () => unwrap(api.POST("/v1/agents/{agent_id}/publish", path)),
    onSuccess: refresh,
  });
  const resume = useMutation({
    mutationFn: () => unwrap(api.PATCH("/v1/agents/{agent_id}", { ...path, body: { status: "live" } })),
    onSuccess: refresh,
  });
  return { publish, resume };
}
